import { Injectable } from '@angular/core';
import { ListService } from 'bookraw/shared/services/list.service';
import { CountryPreset } from "bookraw/shared/models/country-preset.model";

@Injectable()
export class CountryPresetsService extends ListService<CountryPreset> {

  url: string = '/api/admin/countryPresets';
}
